"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "generateTestId", {
  enumerable: true,
  get: function () {
    return _generateTestId.default;
  }
});
Object.defineProperty(exports, "generateTestIdProps", {
  enumerable: true,
  get: function () {
    return _generateTestIdProps.default;
  }
});
var _generateTestId = _interopRequireDefault(require("./generateTestId"));
var _generateTestIdProps = _interopRequireDefault(require("./generateTestIdProps"));
//# sourceMappingURL=index.js.map